import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import Comments from "../components/Comments";

export default function Plan() {
  const [plan, setPlan] = useState({ active: [], resolved: [] });
  const nav = useNavigate();

  const load = async () => {
    const r = await api.get("/plan");
    setPlan(r.data);
  };
  useEffect(() => { load(); }, []);

  const completeDrill = async (drillId) => {
    await api.post("/plan/drills/complete", { drill_id: drillId });
    toast.success("Drill marked done");
    load();
  };

  const resolveItem = async (itemId) => {
    await api.post(`/plan/items/${itemId}/resolve`);
    toast.success("Focus area resolved");
    load();
  };

  return (
    <div>
      <div className="rs-underline mb-3" />
      <h1 className="font-display-heavy text-4xl">YOUR IMPROVEMENT PLAN</h1>
      <p className="text-neutral-400 mt-2">Focus areas evolve as you upload more clips.</p>

      <div className="mt-8">
        <h2 className="font-display-heavy text-2xl mb-4">CURRENT FOCUS</h2>
        {plan.active.length === 0 ? (
          <div className="border border-dashed border-neutral-800 rounded-md p-8 text-neutral-400 text-center">Nothing active. Upload a clip to build your plan.</div>
        ) : (
          <div className="grid gap-4">
            {plan.active.map((item) => (
              <div data-testid={`plan-item-${item.id}`} key={item.id} className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <div className="text-xs uppercase text-neutral-400 font-display tracking-widest">{item.sport}</div>
                    <div className="font-display-heavy text-xl mt-1">{item.title}</div>
                    <p className="text-neutral-300 mt-2">{item.latest_explanation}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-xs uppercase text-neutral-400 font-display tracking-widest">Seen</div>
                    <div className="font-display-heavy text-2xl text-red-500">{item.occurrence_count}×</div>
                  </div>
                </div>
                <div className="mt-4 border-t border-neutral-800 pt-4">
                  <div className="uppercase text-xs text-red-500 font-display tracking-widest mb-3">Drills</div>
                  <div className="space-y-2">
                    {(item.drills || []).map((d) => (
                      <div key={d.id} className={`flex items-start justify-between gap-4 p-3 rounded-md ${d.completed ? "bg-neutral-950 opacity-60" : "bg-neutral-950"}`}>
                        <div>
                          <div className={`font-semibold ${d.completed ? "line-through text-neutral-500" : ""}`}>{d.name}</div>
                          <div className="text-sm text-neutral-400">{d.description}{d.reps && ` · ${d.reps}`}</div>
                        </div>
                        {!d.completed && (
                          <Button data-testid={`complete-drill-${d.id}`} onClick={() => completeDrill(d.id)} variant="outline" className="h-9 border-neutral-700 text-white hover:bg-neutral-800 shrink-0">Mark done</Button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="mt-4 flex flex-wrap justify-between gap-2">
                  <Button data-testid={`compare-progress-${item.id}`} onClick={async () => {
                    try {
                      const r = await api.get(`/plan/${item.id}/progress-compare`);
                      nav(`/compare?a=${r.data.first_analysis_id}&b=${r.data.latest_analysis_id}`);
                    } catch (e) { toast.error(e?.response?.data?.detail || "Need two analyses to compare"); }
                  }} variant="outline" className="h-10 border-neutral-700 text-white hover:bg-neutral-800">Show progress on this fix</Button>
                  <Button data-testid={`resolve-item-${item.id}`} onClick={() => resolveItem(item.id)} variant="ghost" className="text-neutral-400 hover:text-white hover:bg-neutral-800">Resolve focus area</Button>
                </div>
                <Comments focusItemId={item.id} />
              </div>
            ))}
          </div>
        )}
      </div>

      {plan.resolved.length > 0 && (
        <div className="mt-12">
          <h2 className="font-display-heavy text-2xl mb-4">RESOLVED</h2>
          <div className="grid md:grid-cols-2 gap-3">
            {plan.resolved.map((item) => (
              <div key={item.id} className="border border-neutral-800 rounded-md bg-neutral-900 p-4">
                <div className="text-xs uppercase text-neutral-400 font-display tracking-widest">{item.sport}</div>
                <div className="font-display-heavy text-lg text-green-500 line-through">{item.title}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
